import { defineAsyncComponent } from 'vue'

export const getSvgBySystemName = (systemName) => {
  switch (systemName) {
    case 'gift_tip': {
      return defineAsyncComponent(() => import('@/components/svg/properties/GiftTipSvg.vue'))
    }
    case 'no_palmoil': {
      return defineAsyncComponent(() => import('@/components/svg/properties/NoPalmOilSvg.vue'))
    }
    case 'fruit': {
      return defineAsyncComponent(() => import('@/components/svg/properties/FruitSvg.vue'))
    }
    case 'limited_edition': {
      return defineAsyncComponent(() => import('@/components/svg/properties/LimitedEditionSvg.vue'))
    }
    case 'guilty_pleasure': {
      return defineAsyncComponent(() => import('@/components/svg/properties/GuiltyPleasureSvg.vue'))
    }
    case 'no_chemicals': {
      return defineAsyncComponent(() => import('@/components/svg/properties/NoChemicalsSvg.vue'))
    }
    case 'no_sugar_benefit': {
      return defineAsyncComponent(() => import('@/components/svg/properties/NoSugarBenefitSvg.vue'))
    }
    case 'no_added_sugar': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/NoAddedSugarSvg.vue'))
    }
    case 'for_vegan': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/ForVeganSvg.vue'))
    }
    case 'vegan_benefit': {
      return defineAsyncComponent(() => import('@/components/svg/properties/VeganSvg.vue'))
    }
    case 'lyofilized': {
      return defineAsyncComponent(() => import('@/components/svg/properties/LyofilizedSvg.vue'))
    }
    case 'children': {
      return defineAsyncComponent(() => import('@/components/svg/properties/ChildrenSvg.vue'))
    }
    case 'snack': {
      return defineAsyncComponent(() => import('@/components/svg/properties/SnackSvg.vue'))
    }
    case 'travel': {
      return defineAsyncComponent(() => import('@/components/svg/properties/TravelSvg.vue'))
    }
    case 'easy_preparation': {
      return defineAsyncComponent(() => import('@/components/svg/properties/EasyPreparationSvg.vue'))
    }
    case 'chocolate': {
      return defineAsyncComponent(() => import('@/components/svg/properties/ChocolateSvg.vue'))
    }
    case 'nothing_else_needed': {
      return defineAsyncComponent(() => import('@/components/svg/properties/NothingElseNeededSvg.vue'))
    }
    case 'home_snack': {
      return defineAsyncComponent(() => import('@/components/svg/properties/HomeSnackSvg.vue'))
    }
    case 'nutty': {
      return defineAsyncComponent(() => import('@/components/svg/properties/NuttySvg.vue'))
    }
    case 'rich_ingredients': {
      return defineAsyncComponent(() => import('@/components/svg/properties/RichIngredientsSvg.vue'))
    }
    case 'fitness': {
      return defineAsyncComponent(() => import('@/components/svg/properties/FitnessSvg.vue'))
    }
    case 'no_gluten_benefit': {
      return defineAsyncComponent(() => import('@/components/svg/properties/NoGlutenSvg.vue'))
    }
    case 'no_gluten': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/NoGlutenSvg.vue'))
    }
    case 'no_lactose_benefit':
    case 'no_lactose': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/NoLactoseSvg.vue'))
    }
    case 'lactose': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/LactoseSvg.vue'))
    }
    case 'fiber': {
      return defineAsyncComponent(() => import('@/components/svg/properties/FiberSvg.vue'))
    }
    case 'natural': {
      return defineAsyncComponent(() => import('@/components/svg/properties/NaturalSvg.vue'))
    }
    case 'trip_tip': {
      return defineAsyncComponent(() => import('@/components/svg/properties/TripTipSvg.vue'))
    }
    case 'golden_baked': {
      return defineAsyncComponent(() => import('@/components/svg/properties/GoldenBakedSvg.vue'))
    }
    case 'salty': {
      return defineAsyncComponent(() => import('@/components/svg/properties/SaltySvg.vue'))
    }
    case 'recommended': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/RecommendedSvg.vue'))
    }
    case 'bio': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/BioSvg.vue'))
    }
    case 'discount': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/DiscountSvg.vue'))
    }
    case 'new': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/NewSvg.vue'))
    }
    case 'protein': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/ProteinSvg.vue'))
    }
    case 'eko': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/EcoSvg.vue'))
    }
    case 'gift': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/GiftSvg.vue'))
    }
    case 'easter': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/EasterSvg.vue'))
    }
    case 'czechmade': {
      return defineAsyncComponent(() => import('@/components/svg/properties/CzechMadeSvg.vue'))
    }
    case 'exotic': {
      return defineAsyncComponent(() => import('@/components/svg/properties/ExoticSvg.vue'))
    }
    case 'good_deed': {
      return defineAsyncComponent(() => import('@/components/svg/properties/GoodDeedSvg.vue'))
    }
    case 'milk_water': {
      return defineAsyncComponent(() => import('@/components/svg/properties/MilkWaterSvg.vue'))
    }
    case 'crunchy': {
      return defineAsyncComponent(() => import('@/components/svg/properties/CrunchySvg.vue'))
    }
    case 'baked_love': {
      return defineAsyncComponent(() => import('@/components/svg/properties/BakedLoveSvg.vue'))
    }
    case 'to_go_packaging': {
      return defineAsyncComponent(() => import('@/components/svg/properties/ToGoPackagingSvg.vue'))
    }
    case 'full_of_nuts': {
      return defineAsyncComponent(() => import('@/components/svg/properties/FullOfNuts.vue'))
    }
    case 'christmas': {
      return defineAsyncComponent(() => import('@/components/svg/properties/ChristmasSvg.vue'))
    }
    case 'sweet_fiber': {
      return defineAsyncComponent(() => import('@/components/svg/properties/SweetFiberSvg.vue'))
    }
    case 'party': {
      return defineAsyncComponent(() => import('@/components/svg/properties/PartySvg.vue'))
    }
    case 'low_carb': {
      return defineAsyncComponent(() => import('@/components/svg/properties/LowCarbSvg.vue'))
    }
    case 'quick_preparation': {
      return defineAsyncComponent(() => import('@/components/svg/properties/QuickPreparationSvg.vue'))
    }
    case 'family': {
      return defineAsyncComponent(() => import('@/components/svg/properties/FamilySvg.vue'))
    }
    case 'for_baking': {
      return defineAsyncComponent(() => import('@/components/svg/properties/ForBakingSvg.vue'))
    }
    case 'no_nuts_marketing': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/NoNutsSvg.vue'))
    }
    case 'no_nuts_benefit': {
      return defineAsyncComponent(() => import('@/components/svg/properties/NoNutsSvg.vue'))
    }
    case 'gift_box': {
      return defineAsyncComponent(() => import('@/components/svg/properties/GiftBoxSvg.vue'))
    }
    case 'shipping_free': {
      return defineAsyncComponent(() => import('@/components/svg/properties/ShippingFreeSvg.vue'))
    }
    case 'exclusive_discount': {
      return defineAsyncComponent(() => import('@/components/svg/properties/ExclusiveDiscountSvg.vue'))
    }
    case 'without_conditions': {
      return defineAsyncComponent(() => import('@/components/svg/properties/WithoutConditionsSvg.vue'))
    }

    default: {
      console.log('Missing property SVG', systemName)
      return defineAsyncComponent(() => import('@/components/svg/MixitSvg.vue'))
    }
  }
}

export const propertyIcon = (systemName) => {
  switch (systemName) {
    case 'no_added_sugar': {
      return 'no-sugar'
    }
    case 'for_vegan': {
      return 'vegan'
    }
    case 'no_gluten': {
      return 'no-gluten'
    }
    case 'no_lactose_benefit':
    case 'no_lactose': {
      return 'no-lactose'
    }
    case 'lactose': {
      return 'lactose'
    }
    case 'recommended': {
      return 'recommended'
    }
    case 'bio': {
      return 'bio'
    }
    case 'discount': {
      return 'discount'
    }
    case 'new': {
      return 'new'
    }
    case 'protein': {
      return 'protein'
    }
    case 'eko': {
      return 'eko'
    }
    case 'gift': {
      return 'gift'
    }
    case 'easter': {
      return 'easter'
    }
    case 'no_nuts_marketing': {
      return defineAsyncComponent(() => import('@/components/svg/properties/filters/NoNutsSvg.vue'))
    }

    default: {
      return 'bird'
    }
  }
}
